export const sessionKey = ['session']
